<template>
  <cards class="menu-card">
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <delivery-pickup-menu v-if="selectedLocation && selectedLocation.id" :small="true" :isHome="false"
          :showTable="showTable"></delivery-pickup-menu>
      </li>
      <li class="list-group-item">
        <div>

          <p class="text-center text-cart">{{ $t("text.swipe_or_tap") }}</p>
          <p class="text-center text-cart">{{ $t("text.your_order") }} :</p>
          <div v-if="!isCartEmpty" class="items-container">
            <swipe-list :items="newCart.order" item-key="id">
              <template v-slot="{ item, index }">
                <div ref="content" class="card-content clickable" @click="onItemEdit(item, index)">
                  <div class="checkout-menu-Item">
                    <div class="remove-item">
                      <i @click.stop="onItemDelete(index)" class="k-icon-minus-circled"></i>
                    </div>
                    <div class="count-item">
                      <span>{{ item.quantity }}x</span>
                    </div>
                    <div class="description-item">
                      <p>{{ item.name }}</p>
                    </div>
                    <div class="total-price-item">
                      <span>{{
                        getItemPrice(item) | currency(currentCurrency)
                      }}</span>
                    </div>
                    <div class="options-item">
                      <div v-if="item.is_meal_deal && item.sections">
                        <div v-for="(section, sectionIndex) in item.sections" :key="sectionIndex">
                          <div class="mb-2" v-if="
                            section &&
                            section.selected_items &&
                            section.selected_items.length
                          ">
                            <div class="mb-0 ml-2 options-item-grid" v-for="selectedItem in section.selected_items"
                              :key="selectedItem.id">
                              <div class="option-name">
                                {{
                                  `+ ${selectedItem.name} x(${selectedItem.quantity})`
                                }}
                                <div v-html="
                                  formatSubProductOptions(
                                    section,
                                    selectedItem,
                                    'ml-2'
                                  )
                                ">

                                </div>
                              </div>
                              <div class="option-price">{{ selectedItem.price | currency }}</div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div v-if="item.hasOptions" v-html="menuItemOptionFormatter(item.options)"></div>
                    </div>
                    <div class="options-comment" v-if="item.comment">
                      [{{ item.comment }}]
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:right="{ item, index }">
                <div class="swipeout-action red" title="remove" @click="onItemDelete(index, item)">
                  <i class="fa fa-trash"></i>
                </div>
              </template>
            </swipe-list>
          </div>
          <div v-else class="text-center">
            <i class="k-icon-basket-2 icon-style"></i>
            <p class="text-cart">
              {{ $t("empty.cart") }}
            </p>
          </div>
        </div>
      </li>
      <li v-if="user" class="list-group-item">
        <div class="text-center ml-auto mr-auto">
          <fg-input :disabled="isCartEmpty" :placeholder="$t('input.placeholder.enter_coupon')"
            v-model="newCart.coupon"></fg-input>
          <div class="send-button">
            <n-button :style="myTheme.customizeButton" :disabled="isCartEmpty || !newCart.coupon" type="primary"
              @click="onSubmitCoupon(false, true)" round wide>{{ $t("button.submit") }}</n-button>
          </div>
        </div>
      </li>
      <li v-if="!user" class="list-group-item text-center">
        {{ $t("message.redeem_coupon_codes") }}
        <n-button class="nav-link btn-neutral button-center" :style="myTheme.registrationButtons" @click="goToLogin()">
          <i class="now-ui-icons k-icon-login"></i>
          {{ $t("button.login") }}
        </n-button>
      </li>
      <li class="list-group-item checkout-total">
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t("text.sub_total") }}</div>
          <div class="count-column">
            {{ newCart.total | currency(currentCurrency) }}
          </div>
        </div>
      </li>
      <li class="list-group-item checkout-total">
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t("text.service_charges") }}</div>
          <div class="count-column">
            {{ newCart.service_charge | currency(currentCurrency) }}
          </div>
        </div>
      </li>
      <li class="list-group-item checkout-total" v-if="newCart.bag_charge && newCart.bag_charge != '0.00'">
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t("text.bag_charge") }}</div>
          <div class="count-column">
            {{ newCart.bag_charge | currency(currentCurrency) }}
          </div>
        </div>
      </li>
      <li class="list-group-item checkout-total" v-if="newCart.coupon_result">
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t("text.coupon_discount") }}</div>
          <div class="count-column">
            <span>-
              {{
                newCart.coupon_result.discountAmount | currency(currentCurrency)
              }}</span>
          </div>
        </div>
      </li>
      <li class="list-group-item checkout-total" v-if="newCart.orderType === ORDER_TYPE.Delivery.id">
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t("text.delivery_fee") }}</div>
          <div class="count-column">
            {{ newCart.delivery_fee | currency(currentCurrency) }}
          </div>
          <div>
            <p style="font-size: 0.7em" class="recalculated">
              {{ $t("text.recalculate_in_checkout") }}
            </p>
          </div>
        </div>
      </li>

      <li class="list-group-item checkout-total">
        <div class="checkout-total-grid">
          <div class="title-column">{{ $t("text.order_total") }}</div>
          <div class="count-column">
            {{ orderTotal | currency(currentCurrency) }}
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="send-button">
          <n-button :style="myTheme.customizeButton" type="primary" :disabled="!isCheckoutEnabled"
            @click="checkoutOrder()" round block><i v-if="isLoading" class="k-icon-spin4 animate-spin"></i> {{
              $t("button.checkout") }}</n-button>
        </div>
      </li>
    </ul>
  </cards>
</template>
<script>
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { Cards, Button, FormGroupInput, RadioButton } from "@/components";
import { mapState } from "vuex";
import { SwipeList } from "vue-swipe-actions";
import { DeliveryPickupMenu } from "@/layout";
import { couponMixin, orderingMixin } from "@/mixins";
import {
  getMenuItemTotal,
  canMakeOrder,
  menuItemOptionFormatter,
} from "@/utilities/helper";
import { ORDER_TYPE } from "@/utilities/enums";
export default {
  name: "cart-details",
  mixins: [couponMixin, orderingMixin],
  components: {
    DeliveryPickupMenu,
    Cards,
    [RadioButton.name]: RadioButton,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    SwipeList,
  },
  props: {
    action: String,
    hide: Boolean,
    showTable: Boolean,
  },
  data() {
    return {
      menuItemOptionFormatter,
      ORDER_TYPE,
      enabled: true,
      isMounted: false,
      coupon: "",
      deliverFeeStatus: null,
    };
  },
  computed: {
    ...mapState('cartStore', ["orderTotal"]),
    locationStatus: function () {
      return canMakeOrder(this.selectedLocation, this.isMounted);
    },
    isCartEmpty() {
      return !this.newCart || !this.newCart.order || !this.newCart.order.length;
    },
    isOrderable() {
      const { can_make_order } = canMakeOrder(this.selectedLocation);
      return can_make_order;
    },
    isCheckoutEnabled() {
      return !this.isCartEmpty || this.isLoading; //|| !this.isOrderable;
    },

    formatSubProductOptions() {
      return (section, currentItem) => {
        const itemFound = section.subProducts.find(
          (p) => p.id == currentItem.id
        );
        if (!itemFound?.hasOptions || !itemFound.options) return null;
        return menuItemOptionFormatter(itemFound.options)
      };
    },
  },
  methods: {
    onItemDelete(_index) {
      this.$root.$emit("REMOVE_ITEM", _index);
    },
    onItemEdit(_item, _index) {
      this.$root.$emit("PUSH_ITEM", {
        item: { ..._item, ...{ index: _index } },
        openModal: true,
        editMode: true,
      });
    },
    getItemPrice(menuItem) {
      return getMenuItemTotal(menuItem, this.newCart.orderType);
    },
    onAddMoreItems() {
      this.$router.push("/menu");
    },
    addEventListener() {
      this.$root.$off("PUSH_COUPON");
      this.$root.$on("PUSH_COUPON", (code) => {
        this.newCart.coupon = code;
        this.onSubmitCoupon(false, true);
      });
    },
    goToLogin() {
      this.$router.push({ name: "login", query: { redirect: "/menu" } });
    },
    goToHome() {
      this.$router.push("/");
    },
  },
  mounted() {
    this.addEventListener();
    this.isMounted = true;
  },
};
</script>
<style>
.confirm .order-items {
  text-align: left;
  font-size: 1.1em;
}

.confirm p.message {
  font-size: 1em;
  font-weight: bolder;
  line-height: 1.4em;
}

.confirm p i {
  font-size: 5em;
}
</style>
